import React, { useState } from "react";
import { CheckCircle2, ChevronRight, PlayCircle } from "lucide-react";
import { PortalScreen } from "@/components/portal/lp/PortalScreen";
import { StepList } from "./GedBits";
import GedLesson from "./GedLesson";

function LessonRow({ l, onOpen }) {
  const segs = ["learn", "try", "prove"].filter((s) => l.segments[s]).length;
  return (
    <button type="button" onClick={() => onOpen(l)} data-testid={`ged-lesson-${l.id}`}
      className={`w-full flex items-center gap-3 rounded-2xl border-2 p-4 text-left min-h-[72px] ${l.done ? "border-emerald-500/60 bg-emerald-500/10" : "border-white/15 bg-white/[0.04]"}`}>
      {l.done ? <CheckCircle2 className="h-8 w-8 shrink-0 text-emerald-400" /> : <PlayCircle className="h-8 w-8 shrink-0 text-[#d4a017]" />}
      <span className="flex-1"><span className="block text-base font-semibold">{l.title}</span>
        <span className="text-sm text-white/60">{l.done ? `Done · Prove ${l.prove_score}` : segs ? `${segs}/3 parts · pick up where you left off` : "15 minutes · Learn, Try, Prove"}</span></span>
      <ChevronRight className="h-5 w-5 text-white/40" />
    </button>
  );
}

export default function StudyRoadmap({ d, token, voice, onChange }) {
  const [open, setOpen] = useState(null);
  const subs = d.subjects.map((s) => s.key);
  return (
    <div className="space-y-5" data-testid="ged-study">
      <StepList steps={d.steps} />
      {!d.focus && <p className="text-base text-amber-200" data-testid="ged-study-nofocus">Add a baseline score first. Your lessons start with your strongest subject.</p>}
      {subs.map((k) => {
        const s = d.subjects.find((x) => x.key === k);
        return (
          <section key={k} className="space-y-2" data-testid={`ged-study-${k}`}>
            <h3 className="text-sm uppercase tracking-[0.2em] text-[#d4a017]">{s.name}{k === d.focus ? " · focus" : ""}</h3>
            {d.lessons[k].map((l) => <LessonRow key={l.id} l={l} onOpen={setOpen} />)}
          </section>
        );
      })}
      {open && <PortalScreen title={open.title} onBack={() => setOpen(null)} testid="ged-lesson-screen">
        <GedLesson lid={open.id} token={token} voice={voice} onSummary={onChange} onClose={() => setOpen(null)} />
      </PortalScreen>}
    </div>
  );
}
